import { ADD_TICKET, DELETE_TICKET } from "./actionTypes";
import uniqid from "uniqid";

const initialState = {
  tickets: [],
};

const ticketBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TICKET:
      const newTicket = {
        id: uniqid(),
        destinationFrom: action.payload.destinationFrom,
        destinationTo: action.payload.destinationTo,
        journeyDate: action.payload.journeyDate,
        guests: action.payload.guests,
        ticketClass: action.payload.ticketClass,
      };

      return { ...state, tickets: [...state.tickets, newTicket] };

    case DELETE_TICKET:
      const updateTickets = state.tickets.filter(
        (ticket) => ticket.id !== action.payload
      );
      return { ...state, tickets: updateTickets };

    default:
      return state;
  }
};

export default ticketBookingReducer;
